/**
 * TRAD-2546 임시 완화 — `www.xtrading.kr`에서 구글 로그인이 실패한다. `@react-oauth/google`의
 * GSI 위젯이 페이지 origin을 구글 콘솔의 "승인된 자바스크립트 원본"과 비교하는데, `www`가
 * 거기 등록돼 있지 않다(실측 2026-08-13, davidyoon 제보 — Windows에서 www 진입 시 실패,
 * Mac은 apex 진입이라 정상).
 *
 * 근본 처방은 nginx의 www→apex 301 정규화(TRAD-2546 A안, davidyoon 승인 대기 중 — 운영
 * nginx 변경이라 클라 단독으로 못 하는 결정). 그게 적용되면 **이 파일과 `main.tsx`의
 * 호출부를 통째로 삭제한다** — 그때부터 www 요청 자체가 nginx에서 apex로 걸러져 이 코드는
 * 절대 실행되지 않는다(죽은 코드가 된다).
 *
 * 순수 함수로 분리한 이유: 실제 페이지 이동(`window.location.replace`)은 부수효과라 단위
 * 테스트가 어렵다. 이 함수는 location의 각 조각(hostname/pathname/search/hash/protocol)만
 * 받아 "리다이렉트할 URL이 있으면 문자열, 없으면 null"만 계산한다 — 이동 자체는 호출부
 * (`main.tsx`)의 경계로 밀어낸다.
 */
export const resolveWwwApexRedirectUrl = (location: {
  hostname: string;
  pathname: string;
  search: string;
  hash: string;
  protocol: string;
}): string | null => {
  if (location.hostname !== 'www.xtrading.kr') return null;

  // 경로·쿼리·해시를 그대로 보존한다 — 로그인 버튼을 누른 시점이 아니라 어느 페이지에서
  // 들어왔든 www로 유입된 순간(앱 부트스트랩) 즉시 apex로 옮기므로, 사용자가 원래 보려던
  // 페이지가 그대로 이어져야 한다.
  return `${location.protocol}//xtrading.kr${location.pathname}${location.search}${location.hash}`;
};
